module.exports = "/assets/data/1fe67530849a43fa8cf3946d07507313-AB35.data.json";